import type { FaireProductEntity } from "../../entity_types/product";

export const p_anahbgy7u2: FaireProductEntity = {
  token: "p_anahbgy7u2",
  type: "product",
  name: "I ❤️ To Fart Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/4d2a4dd0ab3acb2e0f4899e24f064a8454c227bc02a59619977231c40e5f5e17.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94bb0a7a25bc7be311f30883eb64b2f8c5ab230354a9f29ac79a36cf5c673ae5.jpeg",
    "https://cdn.faire.com/fastly/619e67974217306067e91781e27543ab2c063d75d0d52ff07f4669b73118a54b.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/e9f91cce9fa42f0e0a6d9126c1cb4488784dac86ac3c32c83a916b2e0616e8f6.jpeg"
  ],
  priceDollars: 6.75,
  description: "There's so much to love about life, but time and time again, there's that one special thing that squeaks its way to the top of the list. FARTS! \n\nA new bright gym sock to celebrate the joys of life with you, great cushioned support for your feet so you can jog one out, or kick your feet up and let them sneak out at their leisure. Either way, we know you LOVE to Fart!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:11.422Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
